/* eslint-disable react-hooks/exhaustive-deps */
import React, { Component } from 'react'
import { toast } from 'react-toastify';
import { initFaceMesh } from '../utils/covid/faceLandmarker';
import Dropzone from 'react-dropzone';
import {Container, Row, Col, Button } from 'react-bootstrap';
import imageValidation from '../utils/covid/manualImageValidation';
import Header from '../components/Header';
import LandscapeCenter from '../assets/SVG/landscape-faces/faces-center.svg';
import LandscapeRight from '../assets/SVG/landscape-faces/faces-right.svg';
import LandscapeLeft from '../assets/SVG/landscape-faces/faces-left.svg';
import LandscapeUp from '../assets/SVG/landscape-faces/faces-up.svg';
import { CheckCircle, XCircle } from 'react-bootstrap-icons';
import { getCovidTestResult } from '../api';
import Waiting from '../components/Waiting';
import '../styles/testpage.css';
import covidMessageList from '../enum/covidMessageList';
import QuestionnaireV2 from '../components/QuestionnaireV2';

const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    cursor: "pointer",
    borderWidth: 4,
    borderRadius: 25,
    borderColor: "#0000001f",
    borderStyle: "dashed",
    outline: "none",
    transition: "border .24s ease-in-out"
};

const activeStyle = {
    borderColor: "#2196f3"
};

const acceptStyle = {
    borderColor: "#00e676"
};

const rejectStyle = {
    borderColor: "#ff1744"
};

let isFaceMeshLoaded = false;
let loadInterval;
let countdown = 0;

class UploadTestFiles extends Component {
    constructor(props){
        super(props);
        this.state = {
            cPreview: null,
            rPreview: null,
            lPreview: null,
            uPreview: null,
            cValid: [],
            rValid: [],
            lValid: [],
            uValid: [],
            imageCoordinates: [],
            thumbnails: [],
            isLoading: false,
            dataUrls: [],
            isReady: false,
            isWaiting: false,
            faceMesh: false,
            isSlow: false,
            isLoaded: false,
            isOpen: false,
        };
    }

    componentDidMount = () => {
        document.title = "COVID-19 Test";
        this.loadFaceMesh();
    }

    componentDidUpdate = (prevProps, prevState) => {
        if(
            prevState.dataUrls !== this.state.dataUrls ||
            prevState.cValid !== this.state.cValid ||
            prevState.rValid !== this.state.rValid ||
            prevState.lValid !== this.state.lValid ||
            prevState.uValid !== this.state.uValid
        ) {
            const isReadyUrl = Object.values(this.state.dataUrls).length === this.state.dataUrls.length;
            const isCReady = this.state.cValid.length > 0 && this.state.cValid.every(v => v === true);
            const isRReady = this.state.rValid.length > 0 && this.state.rValid.every(v => v === true);
            const isLReady = this.state.lValid.length > 0 && this.state.lValid.every(v => v === true);
            const isUReady = this.state.uValid.length > 0 && this.state.uValid.every(v => v === true);
            this.setState({
                isReady: isReadyUrl && isCReady && isRReady && isLReady && isUReady
            });
        }       
    }

    notify = (msg) => {
        this.dismissAll();
        toast.error(msg);
    }

    dismissAll = () => toast.dismiss();

    checkStatus = () => {
        countdown += 1;
        if(countdown > 3) {
            this.setState({ isSlow: true })
        }
        
        if(isFaceMeshLoaded) {
            clearInterval(loadInterval);
        }
    }
    
    loadFaceMesh = async() => {
        if (!isFaceMeshLoaded) {
            loadInterval = setInterval(() => {
                this.checkStatus();
            }, 1000);        
            let result = await initFaceMesh();
            if(!result) {
                isFaceMeshLoaded = false;
            } else {
                this.setState({ isLoaded: true }, () => {
                    isFaceMeshLoaded = true;
                });
            }
        } else {
            this.setState({ isLoaded: true }, () => {
                isFaceMeshLoaded = true;
            });
        }
    };

    generateStyles = (isDragActive, isDragAccept, isDragReject) => ({
        ...baseStyle,
        ...(isDragActive ? activeStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    });

    dataURLtoBlob = (dataUrl) => {
        let arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);

        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new Blob([u8arr], {type:mime});
    };

    getDataUrl = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = function(evt) {
                let img = document.createElement("img");
                img.onload = async function(){
                    resolve(img)
                };
                img.src = evt.target.result;
            };
            reader.readAsDataURL(file);
        })
    };

    checkValidation = async (file, direction) => {
        let img = await this.getDataUrl(file);
        let newFiles = this.state.dataUrls;
        newFiles[direction] = img;
        this.setState({
            dataUrls: newFiles
        });

        let validationCanvas = document.createElement('canvas');
        validationCanvas.width = img.width;
        validationCanvas.height = img.height;
        let vctx = validationCanvas.getContext('2d');
        vctx.fillRect(0, 0, img.width, img.height);
        vctx.drawImage(img, 0, 0, img.width, img.height);

        let result = await imageValidation(validationCanvas, direction, img.width, img.height);
        return result;
    };

    validatePicture = async (file, index) => {
        if(!['image/jpeg', 'image/png'].includes(file.type)) {
            this.notify("Invalid file format. Please upload a valid picture format.");
            return;
        }
        this.setState({
            isLoading: true
        })

        const { validations, coordinates} = await this.checkValidation(file, index);
        let newCoordinates = this.state.imageCoordinates;
        newCoordinates[index] = coordinates;

        const keyMapping = {
            0: 'c',
            1: 'r',
            2: 'l',
            3: 'u'
        };
        const keyDirection = keyMapping[index];
        this.setState({
            [`${keyDirection}Valid`]: validations,
            imageCoordinates: newCoordinates,
            [`${keyDirection}Preview`]: URL.createObjectURL(file),
            isLoading: false
        })
    };

    validationMessage = (validations, direction) => {
        let valid = validations.every(v => v === true);
        return <>
            { valid ?  <CheckCircle data-testid={`success-${direction}`} id={`success-${direction}`} className='mt-2' color='Chartreuse' size={32} /> : <XCircle id={`failed-${direction}`} className='mt-2' color='red' size={32} /> }
            {!valid && <p className='text-center text-warning'>
                Please take a photo with these fixes:
                {!validations[0] && ` look ${direction}` }
                {!validations[1] && `, the distance between your eye and camera must be 8" (20cm)` }
                {!validations[2] && `, do not blink` }
                {!validations[3] && `, move to a well-lit environment` }
                {!validations[4] && `, open your eyes wide` }
                {!validations[5] && `, part of the face is out of bounds` }
            </p>}
        </>
    };

    cropImages = (img, coordinates) => {
        let blobData;
        const { out_minxs, out_minys } = coordinates;
        if(out_minxs && out_minys) {
            let out_minx =Math.min(...out_minxs);
            let out_miny =Math.min(...out_minys);

            let out_maxx =Math.max(...out_minxs);
            let out_maxy =Math.max(...out_minys);

            let width = out_maxx - out_minx;
            let height = out_maxy - out_miny;

            let canvasSnapshot = document.createElement('canvas');
            canvasSnapshot.width = width;
            canvasSnapshot.height = height;

            let contextSnapshot = canvasSnapshot.getContext('2d');
            contextSnapshot.fillRect(0, 0, width, height);
            contextSnapshot.imageSmoothingEnabled = true;
            contextSnapshot.imageSmoothingQuality = 'high';
            contextSnapshot.drawImage(img, out_minx, out_miny, width, height, 0, 0, width, height);
            let dataUrl = canvasSnapshot.toDataURL('image/jpeg', 1.0);
            blobData = this.dataURLtoBlob(dataUrl);
        }
                
        return blobData;
    };

    convertFiles = (img, index) => {
        let canvasSnapshot = document.createElement('canvas');

        let aspectRatio = img.width > img.height ? img.width / img.height : img.height / img.width;
        let isLandscape = img.width > img.height ?  true : false;        
        let fixedCanvasWidth = 350;
        let fixedCanvasHeight = isLandscape ? 350 / aspectRatio : 350 * aspectRatio;

        canvasSnapshot.width = fixedCanvasWidth;
        canvasSnapshot.height = fixedCanvasHeight;

        let contextSnapshot = canvasSnapshot.getContext('2d');
        contextSnapshot.fillRect(0, 0, fixedCanvasWidth, fixedCanvasHeight);
        contextSnapshot.imageSmoothingEnabled = true;
        contextSnapshot.imageSmoothingQuality = 'high';
        contextSnapshot.drawImage(img, 0, 0, fixedCanvasWidth, fixedCanvasHeight);
        let dataUrl = canvasSnapshot.toDataURL('image/jpeg', 1.0);
        let dataPNGUrl = canvasSnapshot.toDataURL();
        let newThumbnails = this.state.thumbnails;
        newThumbnails[index] = dataPNGUrl;
        this.setState({ thumbnails: newThumbnails });
        let blobData = this.dataURLtoBlob(dataUrl);
        return blobData;
    };

    uploadFiles = async (qtn) => {
        this.setState({
            isOpen: false,
            isWaiting: true
        })
        // define new form
        let formData = new FormData();

        for (let i = 0; i < this.state.dataUrls.length; i++) {
            let eyeBlobData = this.cropImages(this.state.dataUrls[i], this.state.imageCoordinates[i]);
            let eyeBlob = new Blob([eyeBlobData], { type: "image/jpeg" });
            formData.append('images', eyeBlob, 'eye' + (i + 1) + '.jpg');
        }
        for (let i = 0; i < this.state.dataUrls.length; i++) {
            // define data and connections
            let blobData = this.convertFiles(this.state.dataUrls[i], i);
            let blob = new Blob([blobData], { type: "image/jpeg" });
            formData.append('images', blob, 'capture' + (i + 1) + '.jpg');
        }
        formData.append('coordinates', JSON.stringify(this.state.imageCoordinates));
        formData.append('qtn', JSON.stringify(qtn));
        formData.append("isDemo", this.props.location?.state?.isDemo);

        let result = await getCovidTestResult(formData);
        const totalRetry = 30;
        for( let retry of Array.from(Array(totalRetry).keys())) {
            if(result) break;
            result = await getCovidTestResult(formData);
        }
        if(result) {
            // if(result.test_id) {
            //     formData.append("tid", result.test_id);
            //     setParallelTestResult(formData);
            // }
            this.props.history.push({ 
                pathname: '/result',
                state: { response: result, qtn, profile: this.state.thumbnails, isDemo: this.props.location?.state?.isDemo }
            });
        } else {
            this.notify("Network Error!");
        }

        this.setState({
            isWaiting: false
        })
    };

    render() {
        return (
            <Container>
                <div className='main uploadtest' data-testid="uploadtest">
                    <Header backRoute="/home" />
                    {(this.state.isLoading && this.state.isLoaded) && <div id="cover-spin"></div>}
                    <Waiting isWaiting={!this.state.isLoaded} message="Preparing the environment..." isMulti={false} />
                    <p className="mt-5 heading">Please upload your photos to complete COVID test.</p>
                    <Row xs={{ gutter: 5 }} className='my-5'>
                        <Col xs={12} md={6} xl={3} className="mb-3">
                            <p className="m-0 text-white font-weight-bold heading">Center</p>
                            <Dropzone multiple={false} onDrop={acceptedFiles => this.validatePicture(acceptedFiles[0], 0)}>
                                {({getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject}) => {
                                    const style = this.generateStyles(isDragActive, isDragAccept, isDragReject);
                                    return (
                                        <div {...getRootProps({ style })}>
                                            <input id='centerDropzone' {...getInputProps()} />
                                            <img src={this.state.cPreview ? this.state.cPreview : LandscapeCenter} alt="Center" width="100%" style={{ borderRadius: 25 }} />
                                        </div>
                                    )
                                }}
                            </Dropzone> 
                            {!this.state.cPreview && <p data-testid="centerDragText" className="font-italic text-white mx-1">Drag your file here, or click to select a file.</p>}
                            {
                                this.state.cPreview && this.validationMessage(this.state.cValid, 'center')
                            }
                        </Col>
                        <Col xs={12} md={6} xl={3} className="mb-3">
                            <p className="m-0 text-white font-weight-bold heading">Right</p>
                            <Dropzone multiple={false} onDrop={acceptedFiles => this.validatePicture(acceptedFiles[0], 1)}>
                                {({getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject}) => {
                                    const style = this.generateStyles(isDragActive, isDragAccept, isDragReject);
                                    return (
                                        <div {...getRootProps({ style })}>
                                            <input id="rightDropzone" {...getInputProps()} />
                                            <img src={this.state.rPreview ? this.state.rPreview : LandscapeRight} alt="Right" width="100%" style={{ borderRadius: 25 }} />
                                        </div>
                                    )
                                }}
                            </Dropzone>
                            {!this.state.rPreview && <p data-testid="rightDragText" className="font-italic text-white mx-1">Drag your file here, or click to select a file.</p>}
                            {
                                this.state.rPreview && this.validationMessage(this.state.rValid, 'right')
                            }
                        </Col>
                        <Col xs={12} md={6} xl={3} className="mb-3">
                            <p className="m-0 text-white font-weight-bold heading">Left</p>
                            <Dropzone multiple={false} onDrop={acceptedFiles => this.validatePicture(acceptedFiles[0], 2)}>
                                {({getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject}) => {
                                    const style = this.generateStyles(isDragActive, isDragAccept, isDragReject);
                                    return (
                                        <div {...getRootProps({ style })}>
                                            <input id="leftDropzone" {...getInputProps()} />
                                            <img src={this.state.lPreview ? this.state.lPreview : LandscapeLeft} alt="Left" width="100%" style={{ borderRadius: 25 }} />
                                        </div>
                                    )
                                }}
                            </Dropzone>
                            {!this.state.lPreview && <p data-testid="leftDragText" className="font-italic text-white mx-1">Drag your file here, or click to select a file.</p>}
                            {
                                this.state.lPreview && this.validationMessage(this.state.lValid, 'left')
                            }
                        </Col>
                        <Col xs={12} md={6} xl={3} className="mb-3">
                            <p className="m-0 text-white font-weight-bold heading">Up</p>
                            <Dropzone multiple={false} onDrop={acceptedFiles => this.validatePicture(acceptedFiles[0], 3)}>
                                {({getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject}) => {
                                    const style = this.generateStyles(isDragActive, isDragAccept, isDragReject);
                                    return (
                                        <div {...getRootProps({ style })}>
                                            <input id="upDropzone" {...getInputProps()} />
                                            <img src={this.state.uPreview ? this.state.uPreview : LandscapeUp} alt="Up" width="100%" style={{ borderRadius: 25 }} />
                                        </div>
                                    )
                                }}
                            </Dropzone>
                            {!this.state.uPreview && <p data-testid="upDragText" className="font-italic text-white mx-1">Drag your file here, or click to select a file.</p>}
                            {
                                this.state.uPreview && this.validationMessage(this.state.uValid, 'up')
                            }
                        </Col>
                    </Row>
                    <Row xs={{ gutter: 4 }} className="justify-content-center mt-1 mb-4">
                        <Col xs={6} md={2}>
                            <Button
                                data-testid="submit"
                                id="submit"
                                className="w-100"
                                type="submit"
                                variant={this.state.isReady ? "primary" : "secondary"}
                                disabled={!this.state.isReady}
                                onClick={() => this.setState({ isOpen: true })}
                            >
                                Continue
                            </Button>
                        </Col>
                    </Row>
                </div>
                {this.state.isWaiting && <Waiting isWaiting={this.state.isWaiting} list={covidMessageList} />}
                <QuestionnaireV2 isOpen={this.state.isOpen} onSubmit={this.uploadFiles} />
            </Container>
        )
    }
};

export default UploadTestFiles
